import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { selectIsMaintenanceOngoing, selectRemoteConfigLoadingStatus } from '@qvs/core/remoteConfig';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { sharedRoutePaths } from './shared-route.paths';
import { LoadingStatus } from '@qvs/core';

export const maintenanceCheckGuard: CanMatchFn = (): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const store = inject(Store);

  return store.pipe(
    select(selectRemoteConfigLoadingStatus),
    filter((status) => status === LoadingStatus.SUCCEEDED || status === LoadingStatus.FAILED),
    switchMap(() => store.select(selectIsMaintenanceOngoing)),
    take(1),
    map((isMaintenanceOngoing) => (isMaintenanceOngoing ? router.parseUrl(sharedRoutePaths.MAINTENANCE) : true)),
    catchError(() => of(router.parseUrl(sharedRoutePaths.ERROR)))
  );
};

